/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_DirectoryInputs */

const en_nav_section_directory = /** @type {(inputs: Nav_Section_DirectoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directory`)
};

/**
* | output |
* | --- |
* | "Directory" |
*
* @param {Nav_Section_DirectoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_directory = /** @type {((inputs?: Nav_Section_DirectoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_DirectoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_section_directory(inputs)
});